import { Type } from "class-transformer";
import { AuthRules } from "src/modules/sm-base/shared/AuthRules";
import { FrontendCorporateIdentity } from "src/modules/sm-base/shared/FrontendCorporateIdentity";
import { FrontendField } from "src/modules/sm-base/netgen/FrontendField";
import { GenericObjectDefinition } from "src/modules/sm-base/netgen/GenericObjectDefinition";
import { MainFrontendConfigFieldAccess } from "./MainFrontendConfigFieldAccess";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class MainFrontendConfig {
    customer: string;
    configuredModules: string[];
    activeModules: string[];
    ciFilesFromBackend = true;
    csvToExcelAvailable = true;
    frontendVersionCheckAvailable = true;
    reportBackendErrorsWithFrontendContext = true;
    developerActionsAvailable = false;
    httpOnlyAuthenticationCookieAvailable = false;
    appName: string;
    agGridEnterpriseKey: string;
    @Type(() => FrontendCorporateIdentity)
    corporateIdentity: FrontendCorporateIdentity = new FrontendCorporateIdentity();
    mainRoute: string;
    developer = false;
    showBreadcrumbs = true;
    breadcrumbsInToolBar = true;
    showSidebar = false;
    showBackButton = false;
    showHelpButton = false;
    staticHeaderHtml: string;
    privacyPolicy = false;
    multilingual = false;
    allowedLanguages: string[];
    compactGui = false;
    warningOnSwitchLanguage = true;
    allowDarkMode = false;
    reportErrorsToBackend = true;
    lastBugreportAvailable = false;
    networkLinkedDocumentAllowedPathRegex: string;
    @Type(() => FrontendField)
    additionalUserAttributes: FrontendField[];
    @Type(() => FrontendField)
    additionalUserGroupAttributes: FrontendField[];
    @Type(() => GenericObjectDefinition)
    genericObjectDefinitions: GenericObjectDefinition[];
    @Type(() => AuthRules)
    authRules: AuthRules = new AuthRules();
    useAdminUsers = false;
    adminUsersAllowAdd = true;
    adminUsersFieldAccess: OrdinaryObject<MainFrontendConfigFieldAccess>;
    useAdminUserGroups = false;
    onlyOneGroupPerUser = false;
    useAdminCompanies = false;
    useGlobalEMailTemplates = false;
    globalEmailTemplatesAllowAdd = false;
    usesChangeTracking = false;
}
